module.exports = __webpack_public_path__ + "img/same_score_24dp@2x.77a4e925.png";